



























import { Component, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation, Action } from 'vuex-class';
import { IAttributeFilterState, IFilter, IFilterGroupState } from '@/store/types/IRootState';
import ImageComponent from '@/components/ImageComponent.vue';
import { formatString } from '@/services/StringFormatter';

@Component({
  components: {
    ImageComponent,
  },
  methods: {
    formatString,
  },
})
export default class CompanyFilter extends Vue {

  public numberFiltersToShow: number = 5;

  @Getter
  public getNCompanyFilters!: IFilter[];
  @Getter
  public getShowAllCompanyFilters!: boolean;
  @Getter
  public getNumberOfRemainingCompanyFilters!: number;
  @Getter
  public getCompanyFiltersLength!: number;
  @Getter
  public getShowFilterGroupCompanyFilters!: boolean;
  @Getter
  public displayCompanyFilter!: boolean;

  // mutations
  @Mutation
  private toggleShowAllCompanyFilters: any;
  @Mutation
  private toggleShowFilterGroupCompanyFlag: any;

  @Action private checkCompanyFilter: any;

  public expand = true;
  public toggleExpand() {
    this.expand = !this.expand;
  }
}
